module.exports = __webpack_public_path__ + "static/media/succ-sign.0c5ec624.svg";